// @flow
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Helmet from 'react-helmet'
import { User } from '../../types'
import Table from '../../components/Table'
import Th from '../../components/Th'
import Tr from '../../components/Tr'
import Td from '../../components/Td'
import AdminNav from '../../components/AdminNav'

type Props = {
  users: Array<User>
}

const AdminIndex = ({ users }: Props) => (
  <div style={{ padding: '3rem 0' }}>
    <Helmet title="Admin" />
    <div className="container">
      <div className="row">
        <div className="col-md-2 col-xs-12">
          <AdminNav />
        </div>
        <div className="col-md-10 col-xs-12">
          <Table>
            <thead>
              <Tr>
                <Th>Name</Th>
                <Th>Email</Th>
              </Tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <Tr key={user.id}>
                  <Td>
                    <Link to={`/admin/u/${user.id}`}>{user.name}</Link>
                  </Td>
                  <Td>
                    <Link to={`/admin/u/${user.id}`}>{user.email}</Link>
                  </Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  </div>
)

export default connect((state) => ({
  users: state.admin.users
}))(AdminIndex)



// WEBPACK FOOTER //
// ./src/views/AdminIndex/index.js